// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Recoil from "recoil";
import * as RecoilAtoms$OrcaPaymentPage from "../Utilities/RecoilAtoms.bs.js";
import * as WalletShimmer$OrcaPaymentPage from "./WalletShimmer.bs.js";
import * as PaymentShimmer$OrcaPaymentPage from "./PaymentShimmer.bs.js";

function SessionPaymentWrapper(props) {
  var children = props.children;
  var sessions = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.sessions);
  var loader;
  loader = props.type_ === "Wallet" ? React.createElement(WalletShimmer$OrcaPaymentPage.make, {}) : React.createElement(PaymentShimmer$OrcaPaymentPage.make, {});
  if (typeof sessions !== "object" && sessions === "Loading") {
    return loader;
  } else {
    return children;
  }
}

var make = SessionPaymentWrapper;

export {
  make ,
}
/* react Not a pure module */
